import React, {useState} from 'react';
import {Button} from 'react-bootstrap';

let DeleteButton = (props) => {
  const [disabled, setDisabled] = useState(false);

  const handleDeleteClick = () => {
    setDisabled(true);
    props.onDeleteClick();
  };

  return <Button variant="light" size="sm" title={ props.title } disabled={ disabled } onClick={ handleDeleteClick }>
    <span className="icon icon-trash-empty"></span>{ props.text ? props.text : '' }
  </Button>
};
export default DeleteButton;